export enum ButtonTypeEnum {
  primary = 'primary',
  secondary = 'secondary',
  negative = 'negative',
  accent = 'accent'
}
